/**
 * types.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

export const types = [
  {
    value: 'apartment',
    label: 'Wohnung',
    icon:  () => (
      <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M4,24 C3.44771525,24 3,23.5522847 3,23 L3,1 C3,0.44771525 3.44771525,0 4,0 L20,0 C20.5522847,0 21,0.44771525 21,1 L21,23 C21,23.5522847 20.5522847,24 20,24 L4,24 Z M20,1 L4,1 L4,23 L10,23 L10,20 C10,19.4477153 10.4477153,19 11,19 L13,19 C13.5522847,19 14,19.4477153 14,20 L14,23 L20,23 L20,1 Z M13,20 L11,20 L11,23 L13,23 L13,20 Z M17,11 C17.5522847,11 18,11.4477153 18,12 L18,16 C18,16.5522847 17.5522847,17 17,17 L14,17 C13.4477153,17 13,16.5522847 13,16 L13,12 C13,11.4477153 13.4477153,11 14,11 L17,11 Z M10,11 C10.5522847,11 11,11.4477153 11,12 L11,16 C11,16.5522847 10.5522847,17 10,17 L7,17 C6.44771525,17 6,16.5522847 6,16 L6,12 C6,11.4477153 6.44771525,11 7,11 L10,11 Z M17,12 L14,12 L14,16 L17,16 L17,12 Z M10,12 L7,12 L7,16 L10,16 L10,12 Z M17,3 C17.5522847,3 18,3.44771525 18,4 L18,8 C18,8.55228475 17.5522847,9 17,9 L14,9 C13.4477153,9 13,8.55228475 13,8 L13,4 C13,3.44771525 13.4477153,3 14,3 L17,3 Z M10,3 C10.5522847,3 11,3.44771525 11,4 L11,8 C11,8.55228475 10.5522847,9 10,9 L7,9 C6.44771525,9 6,8.55228475 6,8 L6,4 C6,3.44771525 6.44771525,3 7,3 L10,3 Z M17,4 L14,4 L14,8 L17,8 L17,4 Z M10,4 L7,4 L7,8 L10,8 L10,4 Z" fill="currentColor" />
      </svg>
    )
  },
  {
    value: 'house',
    label: 'Haus',
    icon:  () => (
      <svg width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M5,21 C4.44771525,21 4,20.5522847 4,20 L4,10.4142136 C4,10.1489971 4.10535684,9.89464316 4.29289322,9.70710678 L11.2928932,2.70710678 C11.6834175,2.31658249 12.3165825,2.31658249 12.7071068,2.70710678 L14.5,4.49921356 L14.5,3.5 C14.5,2.94771525 14.9477153,2.5 15.5,2.5 L17,2.5 C17.5522847,2.5 18,2.94771525 18,3.5 L18,7.99921356 L19.7071068,9.70710678 C19.8946432,9.89464316 20,10.1489971 20,10.4142136 L20,20 C20,20.5522847 19.5522847,21 19,21 L5,21 Z M12,3.41421356 L5,10.4142136 L5,20 L8,20 L8,13 C8,12.4477153 8.44771525,12 9,12 L15,12 C15.5522847,12 16,12.4477153 16,13 L16,20 L19,20 L19,10.4142136 L12,3.41421356 Z M15,13 L9,13 L9,20 L15,20 L15,13 Z M17,3.5 L15.5,3.5 L15.5,5.49921356 L17,6.99921356 L17,3.5 Z" fill="currentColor"></path>
      </svg>
    )
  }
];
